import { focusRingSx } from './tokens'

export const pressableResetSx = {
  background: 'transparent',
  border: 'none',
  padding: 0,
  margin: 0,
  font: 'inherit',
  color: 'inherit',
  textAlign: 'left',
  cursor: 'pointer',
  '&[disabled]': {
    cursor: 'not-allowed',
    opacity: 0.4,
    pointerEvents: 'none',
  },
  ...focusRingSx,
}
